module.exports = __webpack_public_path__ + "img/paypal.d66fc7ff.svg";